// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .theme-status-modal-statuses > div.current > div:first-child {
  background: #121417;
}

.theme-status-modal-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--black9);
}
.theme-status-modal-subtitle {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--black5);
}
.theme-status-modal-statuses {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--black9);
  margin-top: 1.25rem;
}
.theme-status-modal-statuses > div {
  margin-right: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.theme-status-modal-statuses > div .theme-status-modal-statuses-loader {
  position: absolute;
  font-size: 10px;
  margin: 0 auto;
  text-indent: -9999em;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--purple5);
  background: linear-gradient(to right, #8164ee 10%, rgba(255, 255, 255, 0) 42%);
  animation: load3 9s infinite linear;
  transform: translateZ(0);
  z-index: -1;
  top: -2px;
  right: -2px;
}
.theme-status-modal-statuses > div .theme-status-modal-statuses-loader:before {
  width: 50%;
  height: 50%;
  background: var(--purple5);
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.theme-status-modal-statuses > div .theme-status-modal-statuses-loader:after {
  background: transparent;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.theme-status-modal-statuses > div.active > div:first-child {
  background: var(--green0);
}
.theme-status-modal-statuses > div.current > div:first-child {
  background: var(--purple0);
  color: var(--purple6);
}
.theme-status-modal-statuses > div > div:first-child {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black5);
  background: var(--black0);
  margin-right: 1rem;
  position: relative;
}
.theme-status-modal-statuses > div:last-child {
  margin-right: 0;
}
.theme-status-modal-progress {
  width: 100%;
  border-radius: 0.75rem;
  background: var(--black2);
  transition: width 1.5s ease;
  height: 0.5rem;
}
.theme-status-modal-progress > div {
  height: 0.5rem;
  border-radius: 0.75rem;
  transition: width 1.5s ease;
  background: var(--purple6);
  animation: color-me-in 3s;
}
@keyframes color-me-in {
  0% {
    width: 0;
  }
  100% {
    width: 8%;
  }
}
.theme-status-modal-step {
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
  margin-bottom: -1rem;
}
.theme-status-modal-step-error {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--red1);
  color: var(--red6);
  padding: 1rem;
  width: 100%;
  margin: 0 auto;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  font-weight: 400;
  background: var(--red0);
  margin-top: 1rem;
  border: 2px solid var(--red6);
}
.theme-status-modal-step-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: var(--black9);
  margin-bottom: 0.25rem;
}
.theme-status-modal-step-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--black5);
  padding: 0 2rem;
}
.theme-status-modal-step-icon {
  min-width: 48px;
  width: 48px;
  height: 48px;
  margin: 0 auto 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.theme-status-modal-step-icon:empty {
  display: none;
}
.theme-status-modal-step-icon-loader {
  position: absolute;
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--purple5);
  background: linear-gradient(to right, #8164ee 10%, rgba(255, 255, 255, 0) 42%);
  animation: load3 3s infinite linear;
  transform: translateZ(0);
  z-index: -1;
  top: -52px;
  right: -2px;
}
.theme-status-modal-step-icon-loader:before {
  width: 50%;
  height: 50%;
  background: var(--purple5);
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.theme-status-modal-step-icon-loader:after {
  background: transparent;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/customization/themes/cards/status/index.scss"],"names":[],"mappings":"AAIQ;EACE,mBAAA;AAHV;;AAcE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAXJ;AAcE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAZJ;AAgBE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,8EAAA;EACA,mCAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAdR;AAgBQ;EACE,UAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAdV;AAiBQ;EACE,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAfV;AAkBQ;EACE;IACE,+BAAA;IACA,uBAAA;EAhBV;EAkBQ;IACE,iCAAA;IACA,yBAAA;EAhBV;AACF;AAmBQ;EACE;IACE,+BAAA;IACA,uBAAA;EAjBV;EAmBQ;IACE,iCAAA;IACA,yBAAA;EAjBV;AACF;AAwBQ;EACE,yBAAA;AAtBV;AA0BQ;EACE,0BAAA;EACA,qBAAA;AAxBV;AA4BM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AA1BR;AA6BM;EACE,eAAA;AA3BR;AAiCE;EACE,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,cAAA;AA/BJ;AAiCI;EACE,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;AA/BN;AAiCM;EACE;IACE,QAAA;EA/BR;EAiCM;IACE,SAAA;EA/BR;AACF;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;AAlCN;AAqCI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AAnCN;AAqCI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAnCN;AAqCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnCN;AAqCM;EACE,aAAA;AAnCR;AAsCM;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,8EAAA;EACA,mCAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AApCR;AAsCQ;EACE,UAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AApCV;AAuCQ;EACE,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AArCV;AAwCQ;EACE;IACE,+BAAA;IACA,uBAAA;EAtCV;EAwCQ;IACE,iCAAA;IACA,yBAAA;EAtCV;AACF;AAyCQ;EACE;IACE,+BAAA;IACA,uBAAA;EAvCV;EAyCQ;IACE,iCAAA;IACA,yBAAA;EAvCV;AACF","sourcesContent":[".dark .theme-status-modal {\n  &-statuses {\n    & > div {\n      &.current {\n        & > div:first-child {\n          background: #121417;\n        }\n      }\n    }\n  }\n\n}\n\n\n.theme-status-modal {\n\n  &-title {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--black9);\n  }\n\n  &-subtitle {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 18px;\n    color: var(--black5);\n  }\n\n\n  &-statuses {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--black9);\n    margin-top: 1.25rem;\n\n    & > div {\n      margin-right: 1rem;\n      display: flex;\n      align-items: center;\n      position: relative;\n\n      .theme-status-modal-statuses-loader {\n        position: absolute;\n        font-size: 10px;\n        margin: 0 auto;\n        text-indent: -9999em;\n        width: 36px;\n        height: 36px;\n        border-radius: 50%;\n        background: var(--purple5);\n        background: linear-gradient(to right, #8164ee 10%, rgba(255, 255, 255, 0) 42%);\n        animation: load3 9s infinite linear;\n        transform: translateZ(0);\n        z-index: -1;\n        top: -2px;\n        right: -2px;\n\n        &:before {\n          width: 50%;\n          height: 50%;\n          background: var(--purple5);\n          border-radius: 100% 0 0 0;\n          position: absolute;\n          top: 0;\n          left: 0;\n          content: '';\n        }\n\n        &:after {\n          background: transparent;\n          width: 75%;\n          height: 75%;\n          border-radius: 50%;\n          content: '';\n          margin: auto;\n          position: absolute;\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n        }\n\n        @-webkit-keyframes load3 {\n          0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n          }\n          100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n          }\n        }\n\n        @keyframes load3 {\n          0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n          }\n          100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n          }\n        }\n\n\n      }\n\n      &.active {\n        & > div:first-child {\n          background: var(--green0);\n        }\n      }\n      &.current {\n        & > div:first-child {\n          background: var(--purple0);\n          color: var(--purple6);\n        }\n      }\n\n      & > div:first-child {\n        min-width: 32px;\n        width: 32px;\n        height: 32px;\n        border-radius: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: var(--black5);\n        background: var(--black0);\n        margin-right: 1rem;\n        position: relative;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n\n  &-progress {\n    width: 100%;\n    border-radius: .75rem;\n    background: var(--black2);\n    transition: width 1.5s ease;\n    height: .5rem;\n\n    & > div {\n      height: .5rem;\n      border-radius: .75rem;\n      transition: width 1.5s ease;\n      background: var(--purple6);\n      animation: color-me-in 3s;\n\n      @keyframes color-me-in {\n        0% {\n          width: 0;\n        }\n        100% {\n          width: 8%;\n        }\n      }\n    }\n  }\n\n  &-step {\n    display: flex;\n    flex-direction: column;\n    margin-top: 2.5rem;\n    margin-bottom: -1rem;\n\n    &-error {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--red1);\n      color: var(--red6);\n      padding: 1rem;\n      width: 100%;\n      margin: 0 auto;\n      border-radius: 0.5rem;\n      font-size: .85rem;\n      font-weight: 400;\n      background: var(--red0);\n      margin-top: 1rem;\n      border: 2px solid var(--red6);\n    }\n\n    &-title {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 19px;\n      text-align: center;\n      color: var(--black9);\n      margin-bottom: .25rem;\n    }\n    &-description {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 20px;\n      text-align: center;\n      color: var(--black5);\n      padding: 0 2rem;\n    }\n    &-icon {\n      min-width: 48px;\n      width: 48px;\n      height: 48px;\n      margin: 0 auto 1.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n\n      &:empty {\n        display: none;\n      }\n\n      &-loader {\n        position: absolute;\n        font-size: 10px;\n        margin: 50px auto;\n        text-indent: -9999em;\n        width: 52px;\n        height: 52px;\n        border-radius: 50%;\n        background: var(--purple5);\n        background: linear-gradient(to right, #8164ee 10%, rgba(255, 255, 255, 0) 42%);\n        animation: load3 3s infinite linear;\n        transform: translateZ(0);\n        z-index: -1;\n        top: -52px;\n        right: -2px;\n\n        &:before {\n          width: 50%;\n          height: 50%;\n          background: var(--purple5);\n          border-radius: 100% 0 0 0;\n          position: absolute;\n          top: 0;\n          left: 0;\n          content: '';\n        }\n\n        &:after {\n          background: transparent;\n          width: 75%;\n          height: 75%;\n          border-radius: 50%;\n          content: '';\n          margin: auto;\n          position: absolute;\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n        }\n\n        @-webkit-keyframes load3 {\n          0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n          }\n          100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n          }\n        }\n\n        @keyframes load3 {\n          0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n          }\n          100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n          }\n        }\n\n\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
